// import { Layout } from "antd";
import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Card, Col, Row } from "antd";
import {
  FundViewOutlined,
  SolutionOutlined,
  UserSwitchOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { SocketContext } from "../../context/socketContext";
const HomePage = () => {
  const userData = useSelector((state) => state.Auth.userData);
  const navigate = useNavigate();
  const { sidebarSetSelectedKey } = useContext(SocketContext);

  // Function to handle navigation and update sidebar state
  const handleNavigation = (path) => {
    console.log("Navigating to:", path);
    console.log("sidebarSetSelectedKey function:", sidebarSetSelectedKey);
    navigate(path);
    if (sidebarSetSelectedKey) {
      sidebarSetSelectedKey(path);
      console.log("Called sidebarSetSelectedKey with:", path);
    } else {
      console.log("sidebarSetSelectedKey is not available");
    }
  };

  const items = [
    {
      key: "0",
      title: "Widget",
      icons: <FundViewOutlined style={{ fontSize: "26px" }} />,
      content: "Embed and customize the widget on your website.",
      class: "",
      href: "/brands",
    },

    {
      key: "2",
      icons: <UserSwitchOutlined style={{ fontSize: "26px" }} />,
      title: "History",
      content: "Track the conversations you have with customers.",
      class: "served",
      href: "/history",
    },
    {
      key: "3",
      icons: <SolutionOutlined style={{ fontSize: "26px" }} />,
      title: "Tickets",
      content: "See customers request ticket while you offline.",
      class: "ticket",
      href: "/tickets",
    },
    {
      key: "4",
      title: "Visitor",
      icons: <UsergroupAddOutlined style={{ fontSize: "26px" }} />,
      content:
        "See a list of visitors to your website and start a conversation.",
      class: "agent",
      href: "/visitors",
    },
  ];
  return (
    <>
      <div className="home">
        <div className="home-title">
          <h6>Hello, {userData?.sudoName}!</h6>
        </div>
        <Row gutter={[16, 16]}>
          {items?.map((item) => {
            return (
              <Col
                xs={{ span: 24 }}
                sm={{ span: 12 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                xl={{ span: 12 }}
                xxl={{ span: 6 }}
                onClick={() => handleNavigation(item.href)}
                key={item.key}
                style={{ cursor: "pointer" }}
              >
                <Card className={`dashboardCard ${item.class}`}>
                  <div className="box">
                    <div className="boxContent">
                      <h3>{item.title}</h3>
                      <div className="boxFooter">
                        <p>{item.content}</p>
                      </div>
                    </div>
                    <div className="boxIcon">{item?.icons}</div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </>
  );
};

export default HomePage;
